export default {
  about: {
    hero: {
      eyebrow: 'Sobre nosotros',
      title: 'Personal. Profesional. Preciso.',
      lead: '{{name}} representa videovigilancia planificada individualmente y atención personal de un solo proveedor.',
    },
    story: {
      quote: '«En vez de vender paquetes prefabricados, cada inmueble se estudia según sus necesidades reales, de las zonas de imagen deseadas a los puntos de montaje, la grabación y la app.»',
      p1: '{{name}} está dirigida por {{owner}}, su contacto personal desde la primera consulta hasta el mantenimiento continuo. Lleva más de 20 años en la seguridad y ha realizado cientos de proyectos para particulares y empresas.',
      p2: 'La amplia experiencia abarca la planificación e instalación de sistemas de cámaras en viviendas, edificios, comercios, oficinas, consultas, hostelería, almacenes, talleres y áreas de producción. Cada proyecto se estudia individualmente.',
      p3: 'Según los requisitos del proyecto, {{name}} utiliza sistemas contrastados de Hikvision y Safire. También se pueden planificar soluciones de otros fabricantes.',
      p4: '{{name}} no se ve como un simple vendedor, sino como un socio a largo plazo. Tras la instalación se mantiene el contacto personal.',
    },
    owner: {
      subtitle: 'Seguridad desde Hainburg',
      photoPlaceholder: 'Foto del propietario próximamente',
      role: 'Propietario y contacto',
    },
    milestonesTitle: 'Experiencia que se nota',
    milestones: {
      '0': { year: 'Más de 20 años', desc: 'Experiencia planificando e instalando sistemas de cámaras para particulares y empresas en la región Rin-Meno.' },
      '1': { year: 'Cientos de proyectos', desc: 'De viviendas a comercios y grandes instalaciones: cada proyecto planificado individualmente.' },
      '2': { year: 'Independiente del fabricante', desc: 'Elegimos la tecnología adecuada para sus necesidades, según el proyecto, de varios fabricantes.' },
    },
    valuesTitle: 'Lo que define a {{name}}',
    values: {
      '0': { title: 'Planificación individual', desc: 'Sin paquetes prefabricados. Cada inmueble se estudia según su necesidad real.' },
      '1': { title: 'Ejecución profesional', desc: 'Instalación limpia, orientación correcta y cableado profesional.' },
      '2': { title: 'Conexión digital', desc: 'App, acceso remoto y notificaciones, configurados y explicados.' },
      '3': { title: 'Atención personal', desc: 'Un contacto. De confianza. Fiable. Incluso tras la instalación.' },
    },
    cta: {
      title: 'Conózcanos',
      lead: 'Una primera conversación sin compromiso muestra rápido si encajamos. Estaremos encantados de conocer su proyecto.',
      primary: 'Concertar una cita',
      secondary: 'Preguntas frecuentes',
    },
  },
};